import { Composition } from 'remotion';
import { RotatingParticleField3D } from '../effects/Effects164-166';
import { WhipPan } from '../effects/WhipPan';
import { WaveParticleField } from '../effects/WaveParticleField';
import { ChromaticAberration } from '../effects/ChromaticAberration';
import { LiquidDistortion } from '../effects/LiquidDistortion';
import { MagneticText } from '../effects/MagneticText';
import { ParticleExplosionEnhanced } from '../effects/ParticleExplosionEnhanced';
import { ParallaxMountains } from '../effects/ParallaxMountains';
import { MathDemoPro } from '../MathDemoPro';
import { PhysicsDemoPro } from '../PhysicsDemoPro';
import { ChemistryDemoPro } from '../ChemistryDemoPro';
import { BiologyDemoPro } from '../BiologyDemoPro';
import { ProjectileMotionTemplate } from '../templates/ProjectileMotion';
import { HistoricalTimelineTemplate } from '../templates/HistoricalTimeline';
import {
  ChineseTemplateV2,
  MathTemplateV2,
  EnglishTemplateV2,
  PhysicsTemplateV2,
  ChemistryTemplateV2,
  BiologyTemplateV2,
  HistoryTemplateV2,
  GeographyTemplateV2,
  PoliticsTemplateV2,
} from '../EducationTemplatesV2';

export const EarlyResearchCompositions = () => (
  <>
      {/* 🎨 新效果 #164-166：2026-03-02 最新研究（22:35） */}
      <Composition
        id="RotatingParticleField3D"
        component={RotatingParticleField3D}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={{
          text: '3D FIELD',
          particleCount: 300,
          color: '#ff6b6b',
          backgroundColor: '#0a0a0a',
        }}
      />
      {/* 🎬 新效果 #167：2026-03-03 最新研究 */}
      <Composition
        id="WhipPan"
        component={WhipPan}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
      />

      <Composition
        id="WaveParticleField"
        component={WaveParticleField}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={{
          particleCount: 200,
          waveAmplitude: 50,
          waveFrequency: 0.05,
          backgroundColor: '#0a0a1a',
          primaryColor: '#4ecdc4',
          secondaryColor: '#ff6b6b',
        }}
      />
      {/* 新效果 176-178（2026-03-03 研究 - Remotion 官方资源）*/}
 
      {/* 🎨 新效果 #179-181：2026-03-03 最新研究 */}
      <Composition
        id="LiquidDistortion"
        component={LiquidDistortion}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
      />
      <Composition
        id="MagneticText"
        component={MagneticText}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
      />
      {/* 🎨 2026-03-03 新效果（#182-184）✨ 最新 */}
      <Composition
        id="ChromaticAberration"
        component={ChromaticAberration}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
      />
      <Composition
        id="Math-Demo-Pro"
        component={MathDemoPro}
        durationInFrames={1800}
        fps={30}
        width={1920}
        height={1080}
      />
      <Composition
        id="Physics-Demo-Pro"
        component={PhysicsDemoPro}
        durationInFrames={1800}
        fps={30}
        width={1920}
        height={1080}
      />
      <Composition
        id="Chemistry-Demo-Pro"
        component={ChemistryDemoPro}
        durationInFrames={1800}
        fps={30}
        width={1920}
        height={1080}
      />
      <Composition
        id="Biology-Demo-Pro"
        component={BiologyDemoPro}
        durationInFrames={1800}
        fps={30}
        width={1920}
        height={1080}
      />

      {/* 🎓 教育模板 V2 - 专业设计版 */}

      {/* 📚 教育视频模板（实用性研究） */}
      <Composition
        id="Educational-ProjectileMotion"
        component={ProjectileMotionTemplate}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={{
          v0: 20,
          angle: 45,
          g: 9.8,
          showVectors: true,
          showTrajectory: true,
          showMaxHeight: true,
          showRange: true,
          animationDuration: 5,
          colors: {
            background: '#F0F9FF',
            ground: '#059669',
            trajectory: '#3B82F6',
            ball: '#EF4444',
            vector: '#F59E0B',
            text: '#1F2937',
            highlight: '#10B981',
          },
        }}
      />
      <Composition
        id="Educational-HistoricalTimeline"
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        component={HistoricalTimelineTemplate as React.ComponentType<any>}
        durationInFrames={450}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={{
          events: [
            {
              year: '公元前 221 年',
              title: '秦始皇统一六国',
              description: '秦始皇嬴政统一六国，建立中国历史上第一个中央集权制国家。',
              icon: '👑',
            },
            {
              year: '公元前 206 年',
              title: '汉朝建立',
              description: '刘邦建立汉朝，开创了中国历史上最辉煌的朝代之一。',
              icon: '🏛️',
            },
            {
              year: '公元 220 年',
              title: '三国鼎立',
              description: '东汉灭亡，魏、蜀、吴三国形成鼎立局面。',
              icon: '⚔️',
            },
            {
              year: '公元 581 年',
              title: '隋朝统一',
              description: '杨坚建立隋朝，结束了南北朝分裂局面。',
              icon: '🗡️',
            },
            {
              year: '公元 618 年',
              title: '唐朝建立',
              description: '李渊建立唐朝，开创了中国历史上最繁荣的时期。',
              icon: '🏮',
            },
          ],
          colors: {
            primary: '#3B82F6',
            secondary: '#10B981',
            accent: '#F59E0B',
            background: '#0F172A',
            text: '#F9FAFB',
            timeline: '#475569',
          },
          durationPerEvent: 3,
          layout: 'vertical',
        }}
      />

      {/* 🎨 2026-03-03 新效果（#185-#187）· 已统一优化为单一模板 */}
      <Composition
        id="ParallaxMountains"
        component={ParallaxMountains}
        durationInFrames={180}
        fps={30}
        width={1920}
        height={1080}
      />
      {/* 🎨 2026-03-03 新效果（#191-#192）✨ 最新（12:35） */}
      {/* 🎬 OpenClaw AI 助手介绍视频（2026-03-04） */}
      {/* 🎨 2026-03-04 新效果（#267-#269）✨ 每日研究任务 */}
      <Composition
        id="ParticleExplosionEnhanced"
        component={ParticleExplosionEnhanced}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
      />
  </>
);
